export default "__VITE_ASSET__C8yBXZ2v__"